import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import notFoundStyle from './NotFound.module.scss';
import IButton from '../../components/elements/iButton/IButton';
import { RoutesUrl } from '../../router/RouterUrls';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const NotFound = observer(() => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <section className={notFoundStyle.section}>
            <div className={notFoundStyle.inner}>
                <span className={notFoundStyle.code}>404</span>
                <h1 className={notFoundStyle.title}>{t('notFound.notFoundMessage')}</h1>
                <p className={notFoundStyle.description}>{t('notFound.description')}</p>
                <IButton
                    title={t('notFound.backHome')}
                    onClick={() => navigate(RoutesUrl.home)}
                    variant='primary'
                    size='lg'
                    icon={<ArrowForwardIcon />}
                />
            </div>
        </section>
    );
});

export default NotFound;
